import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=af8f80f8&"
import script from "./modules.vue?vue&type=script&lang=js&"
export * from "./modules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports